import React, { FC } from "react";
import { useJWT } from "../../state";
import Page from "../common/navigation/Page";
import ListBlock from "../common/F7/ListBlock";
import ListBlockItem from "../common/F7/ListBlockItem";

const DatabaseSelectPage: FC = () => {
  const jwt = useJWT();
  const databases = jwt?.db.map((d) => (typeof d === "string" ? d : d.name)) || [];

  return (
    <Page title="Select a database" noToolbar>
      {databases.length === 0 ? (
        <p>Please contact your administrator, no database configured for your account</p>
      ) : (
        <ListBlock>
          {databases.map((db) => (
            <ListBlockItem key={db} title={db} to={`/d/${db}`} />
          ))}
        </ListBlock>
      )}
    </Page>
  );
};

export default DatabaseSelectPage;
